import BaseComponent from "../../../../../../lib/components/BaseComponent";
import {Mail} from "react-feather";
import React from "react";
import PropTypes from "prop-types";


class UpdateCard extends BaseComponent {
    render() {
        return <div className={'rounded-md p-5 border border-2 border-gray-200 flex flex-col w-full lg:w-1/2 xl:w-1/4 justify-center items-center h-min-20'}>
                {this.props.children}
                <h3 className={'text-center mt-3 text-cn-color-white'}>{this.props.title}</h3>
                <p className={'text-center mt-3 text-cn-color-white'}>{this.props.description}</p>
            </div>


    }
}

UpdateCard.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
}

export default UpdateCard;